/**
 * The theme's own variant-picker JS (product-info.js) re-evaluates the buy
 * button on every variant switch - and on a rented easyrent variant it just
 * disables the button and writes its own generic "Ausverkauft" text, with no
 * idea that "gerade vermietet" is a different thing worth saying. It reuses
 * the same button node (doesn't re-render it from the server), so nothing
 * server-side - not even a perfectly fresh, uncached fetch - can catch this;
 * only watching the button client-side and correcting the label after the
 * fact works. This does that: it reads a small per-variant rental map that
 * buy-buttons.liquid embeds next to the button (together with the
 * theme-locale-translated label, so this stays correct in every storefront
 * language without hardcoding text here), and whenever the button ends up
 * disabled for a variant that easyrent has marked as rented (rather than
 * actually out of stock), it swaps the generic label back to the correct one.
 */
(function () {
  function rentalMapFor(sectionId) {
    var script = document.querySelector('[data-easyrent-rental-map="' + sectionId + '"]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function currentVariantId(btn) {
    var form = btn.closest('form');
    var input = form && form.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  function correct(btn) {
    if (!btn.disabled) return;
    var sectionId = btn.getAttribute('data-section-id');
    var map = rentalMapFor(sectionId);
    if (!map || !map.label) return;
    var variantId = currentVariantId(btn);
    if (!variantId || !map.variants || !map.variants[variantId]) return;
    var span = btn.querySelector('span');
    if (span && span.textContent.trim() !== map.label) {
      span.textContent = map.label;
    }
  }

  function watch(btn) {
    correct(btn);
    var observer = new MutationObserver(function () {
      correct(btn);
    });
    observer.observe(btn, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function init() {
    document.querySelectorAll('[data-easyrent-rental-button]').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Same underlying problem for rental-info-card.liquid: its five values
 * (Pistentage/Gefahren von/Aktuell vermietet/Frühestens verfügbar/Barcode)
 * are per-VARIANT, but the theme doesn't re-fetch the section from the
 * server on a variant switch - it mutates the existing DOM via its own JS.
 * So the card would keep showing the variant that was selected on page
 * load. This reads the per-variant text map rental-info-card.liquid embeds
 * (already translated/formatted server-side) and swaps the five spans
 * whenever the hidden variant-id input changes.
 */
(function () {
  function infoMapFor(productId) {
    var script = document.querySelector('[data-easyrent-info-map="' + productId + '"]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function variantIdInput(card) {
    var scope = card.closest('.shopify-section') || document;
    return scope.querySelector('input[name="id"]');
  }

  function apply(card) {
    var input = variantIdInput(card);
    var variantId = input ? input.value : null;
    if (!variantId || variantId === card.getAttribute('data-easyrent-current-variant')) return;
    var map = infoMapFor(card.getAttribute('data-easyrent-product-id'));
    var data = map && map[variantId];
    if (!data) return;
    card.setAttribute('data-easyrent-current-variant', variantId);
    var fields = {
      'data-easyrent-info-days': data.days,
      'data-easyrent-info-count': data.count,
      'data-easyrent-info-rented': data.rented,
      'data-easyrent-info-available': data.available,
      'data-easyrent-info-barcode': data.barcode,
    };
    Object.keys(fields).forEach(function (attr) {
      var el = card.querySelector('[' + attr + ']');
      if (el) el.textContent = fields[attr];
    });
  }

  function watch(card) {
    var input = variantIdInput(card);
    var scope = card.closest('.shopify-section') || document;
    // Native variant swatches/radios/selects fire a bubbling 'change' event;
    // by the time it reaches this delegated listener the theme's own
    // handler (bound directly on the input) has already updated the hidden
    // id input, so the new variant id is ready to read.
    scope.addEventListener('change', function () {
      apply(card);
    });
    // Belt-and-suspenders for variant pickers that select via click without
    // a native 'change' event (custom swatch/button widgets) and for themes
    // that set the hidden input's value as an attribute rather than only
    // the JS property.
    scope.addEventListener('click', function () {
      setTimeout(function () {
        apply(card);
      }, 50);
    });
    if (input) {
      var observer = new MutationObserver(function () {
        apply(card);
      });
      observer.observe(input, { attributes: true, attributeFilter: ['value'] });
    }
  }

  function init() {
    document.querySelectorAll('[data-easyrent-info-card]').forEach(function (card) {
      watch(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
